import { StarIcon } from "@heroicons/react/solid";

import classNames from "lib/classNames";

export interface UserBookRatingProps {
  rating?: number;
  size?: number;
}

export default function Stars({
  rating = null,
  size = 6,
}: UserBookRatingProps) {
  const halfSize = size / 2;

  return (
    <div className="relative flex flex-row">
      {[0, 1, 2, 3, 4].map(star => (
        <div key={`star-${star}`} className={`relative h-${size} w-${size}`}>
          <StarIcon
            className={classNames(
              `absolute h-${size} w-${size}`,
              rating >= star + 1 ? "text-yellow-400" : "",
              rating < star + 1 ? "text-gray-400" : "",
            )}
          />
          <span className={`absolute h-${size} w-${halfSize} overflow-hidden`}>
            <StarIcon
              className={classNames(
                `absolute h-${size} w-${size}`,
                rating >= star + 0.5 ? "text-yellow-400" : "",
                rating < star + 0.5 ? "text-gray-400" : "",
              )}
            />
          </span>
        </div>
      ))}
    </div>
  );
}
